.editable {
  cursor: text;
}

.error {
  margin-top: 0.8rem;
  color: var(--color-error);
}
